export enum LayoutType {
  None = '',
  Page = 'page',
  Plugin = 'plugin',
}
